import React from "react";

// Decorative botanical line-art sprig. Purely ornamental.
export function Botanical({ className = "", stroke = "#C6A15B" }) {
  return (
    <svg viewBox="0 0 120 160" fill="none" className={className} aria-hidden="true">
      <path d="M60 158 C60 120 60 40 60 4" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
      {[...Array(5)].map((_, i) => {
        const y = 34 + i * 26;
        return (
          <g key={i}>
            <path
              d={`M60 ${y} C42 ${y - 12} 26 ${y - 6} 20 ${y + 8} C34 ${y + 12} 50 ${y + 6} 60 ${y}`}
              stroke={stroke}
              strokeWidth="1.2"
              strokeLinecap="round"
            />
            <path
              d={`M60 ${y - 6} C78 ${y - 18} 94 ${y - 12} 100 ${y + 2} C86 ${y + 6} 70 ${y} 60 ${y - 6}`}
              stroke={stroke}
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
        );
      })}
    </svg>
  );
}

export function LotusDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-gold/60" />
      <svg width="28" height="20" viewBox="0 0 28 20" fill="none">
        <path d="M14 18 C10 12 6 10 2 10 C4 4 10 2 14 8 C18 2 24 4 26 10 C22 10 18 12 14 18Z" stroke="#C6A15B" strokeWidth="1.2" />
      </svg>
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-gold/60" />
    </div>
  );
}
